import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import CompletedIcon from "@public/images/icons/completed.svg";
import NotCompletedIcon from "@public/images/icons/not-completed.svg";
import {
  Container,
  Title,
  TimelineList,
  TimelineItem,
  IconWrapper,
  ContentWrapper,
  StatusText,
  DateTimeText,
  ConnectorLine,
  SeparatorLine,
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

interface OrderStatus {
  status: string;
  heading: string;
  subHeading: string;
  isCompleted: string | boolean;
  imgSrc: string;
  statusUpdatedOn: string;
}

const DeliveryTimeline = (props: any) => {
  const { is_visible, delivery_status = [], title } = props;

  if (!is_visible) return <></>;

  const isCompleted = (completed: string | boolean) => {
    if (typeof completed === "string") {
      return completed.toLowerCase() === "true";
    }
    return Boolean(completed);
  };

  return (
    <Container>
      <Title>{title}</Title>
      <TimelineList>
        {delivery_status.map((item: OrderStatus, index: number) => {
          const completed = isCompleted(item.isCompleted);
          const isLast = index === delivery_status.length - 1;

          return (
            <React.Fragment key={index}>
              <TimelineItem>
                <IconWrapper>
                  {completed ? (
                    <CompletedIcon width={20} height={20} />
                  ) : (
                    <NotCompletedIcon width={20} height={20} />
                  )}
                  {!isLast && (
                    <ConnectorLine isCompleted={completed} />
                  )}
                </IconWrapper>
                <ContentWrapper>
                  <StatusText>{item.status}</StatusText>
                  <DateTimeText>
                    {item.statusUpdatedOn || "---"}
                  </DateTimeText>
                </ContentWrapper>
              </TimelineItem>
              {!isLast && <SeparatorLine />}
            </React.Fragment>
          );
        })}
      </TimelineList>
    </Container>
  );
};

export default connect(mapStateToProps)(DeliveryTimeline);

